import { Deserializable } from '../_common/deserializable';

export class SmsCount implements Deserializable{
    shortCode: string;
    keyword: string;
    affiliate: string;
    subscribeCount: number;
    subscribeAmount: string;
    unsubscribeCount: number;
    unsubscribeAmount: string;
    reminderCount: string;
    retentionArr: string;
    reminderAmount: string;
    mtChargeCount: number;
    mtChargeAmount: string;
    mtFreeCount: number;
    mtFreeAmount: string;
    otpCount: number;
    otpAmount: string;
    totalAmount: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
